import { Component, inject, ViewChild } from '@angular/core';
import { MatTabNavPanel } from '@angular/material/tabs';
import { RouterSelectors } from '@next/core-lib/router-store';
import { SiteState } from '@next/core-lib/site';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { getSelectedCustomerId } from '../../store/customer.selectors';

@Component({
  selector: 'app-customer-navigation',
  templateUrl: './customer-navigation.component.html',
  standalone: false,
})
export class CustomerNavigationComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  @ViewChild('tabPanel') tabPanel: MatTabNavPanel;

  customerId$: Observable<number> = this.store.select(getSelectedCustomerId);

  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getUrl));

  isLocations$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('location') > 0),
  );
  isDetails$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('location') === -1),
  );
}
